import React,{Component} from 'react';
import { Layout } from 'antd';
import MHeader from './Header/header';
import MFooter from './Footer/footer';
import {withRouter} from 'react-router';
import ContentContactWay from './Content/contentContactWay';
import ContentReserve from './Content/contentReserve';
import $ from 'jquery';

import './App.css';

class App extends Component{

  constructor(props){
    super(props);
    this.isIE11Browers=this.isIE11Browers.bind(this);
    this.disableContentSelect=this.disableContentSelect.bind(this);
  }


  componentWillMount=()=>{
    // window.scrollTo(200,0);
  }

  componentDidMount=()=>{
    this.disableContentSelect();
  }

  disableContentSelect=()=>{
      //禁用右键复制
      $(document).bind("contextmenu copy selectstart", function() {
        return false;
      });

      //禁用Ctrl+C、V复制
      $(document).keydown(function(e) {
        if(e.ctrlKey && (e.keyCode == 65 || e.keyCode == 67)) {
          return false;
        }
      });

      //CSS禁止选择
      $(function() {
        $("body").css({
          "-moz-user-select":"none",
          "-webkit-user-select":"none",
          "-ms-user-select":"none",
          "-khtml-user-select":"none",
          "-o-user-select":"none",
          "user-select":"none"
        });
      });
  }


  // 判断是否为IE11浏览器
  isIE11Browers=()=>{
    if (!!window.ActiveXObject || "ActiveXObject" in window){
        return true;
    }else{
        return false;
    }
  }

  render(){
    return(
      <div className="App">
        <Layout>
          <Layout.Header>
            <MHeader headerMenuSelectIndex={this.getSelectIndex()}/>
          </Layout.Header>
          <Layout.Content style={{width: 1920,  margin: '16px auto', maxWidth:'100%', display: 'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
            {this.props.children}
            <ContentContactWay />
          </Layout.Content>
          <Layout.Footer style={{padding: 'unset', height: 'unset'}}>
            <MFooter />
          </Layout.Footer>
        </Layout>
      </div>
    )
  }

  getSelectIndex() {
    const pathname = this.props.location.pathname
    if(pathname.indexOf('/home') !== -1) {
      return 0;
    } else if(pathname.indexOf('/about') !== -1) {
      return 1;
    } else if(pathname.indexOf('/bussiness') !== -1) {
      return 2;
    } else if(pathname.indexOf('/policy') !== -1) {
      return 3;
    } else if(pathname.indexOf('/news') !== -1) {
      return 4;
    } else if(pathname.indexOf('/techFinance') !== -1) {
      return 5;
    } else if(pathname.indexOf('/recruitment') !== -1) {
      return 6;
    }
    // } else if(this.props.location.hash.indexOf('/recruitment#contact-us') !== -1){
    //   return 7;
    // }
  }
}

export default withRouter(App);
